<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item :to="{ name: 'webhotel-list' }" exact>Webhotell</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>{{ state.servername }}</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="webhotel-detail" key="webhotel-detail" />

        <v-form>
          <v-card class="pa-3" raised>
            <h3>FTP informasjon</h3>

            <v-text-field
              label="Full sti"
              :value="state.root"
              readonly
            ></v-text-field>
            <v-text-field
              label="FTP host"
              value="217.171.199.100"
              readonly
            ></v-text-field>
            <v-text-field
              label="Brukernavn"
              :value="state.uid"
              readonly
            ></v-text-field>

            <password-input
              :confirm="true"
              :numCharacters="8"
              @passwordChanged="passwordChanged"
            />

            <v-card-actions>
              <v-btn
                @click="updatePassword"
                :disabled="this.password.length === 0"
              >
                Sett nytt passord
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card class="pa-3 mt-3" raised>
            <h3>Passordbeskyttelse</h3>

            <notifications group="webhotel-detail-passwordProtected" key="webhotel-detail-passwordProtected" />

            <v-card-text>
              <v-layout
                  v-for="(password, i) in state.passwordProtected"
                  :key="state.servername + '-password-' + i"
                  row wrap
                >
                <v-flex xs12 sm4>
                  <v-text-field
                    hide-details
                    label="Sti"
                    v-model="state.passwordProtected[i].path"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    hide-details
                    label="Brukernavn"
                    v-model="state.passwordProtected[i].username"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    type="password"
                    hide-details
                    label="Passord"
                    v-model="state.passwordProtected[i].password"
                    append-icon="close"
                    @click:append="state.passwordProtected.splice(i, 1)"
                  ></v-text-field>
                  <div class="hidden-sm-and-up">&nbsp;</div>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-spacer />
            <v-card-actions>
              <v-btn @click="state.passwordProtected.push({path: '', username: '', password: ''})">Ny</v-btn>
              <v-spacer />
              <v-btn
                color="green darken-2"
                dark
                @click="savePasswordProtects"
              >
                Lagre
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WebhotelService from '@/services/WebhotelService'

export default {
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      passwordErrors: [],
      password: '',
      state: {}
    }
  },
  methods: {
    passwordChanged (v) {
      this.password = v
    },
    async init () {
      const response = await this.runService(this, 'webhotel-detail', WebhotelService.get, this.servername)
      if (response) {
        this.state = response.data
        this.state.passwordProtected.forEach(pass => {
          pass.password = 'provisorisk'
        })
      }
    },
    async updatePassword () {
      if (this.password.length === 0) {
        this.passwordErrors = ['Du må fylle inn et passord']
        return
      }

      const response = await this.runService(this, 'webhotel-detail', WebhotelService.updatePassword, this.servername, this.password)
      if (response) {
        this.goBack('Passordet ble oppdatert!')
      }
    },
    async savePasswordProtects () {
      let hasErrors = false
      this.state.passwordProtected.forEach(pass => {
        if (pass.path && pass.username.length * pass.password.length === 0) {
          hasErrors = true
          this.addNotification(true, {
            group: 'webhotel-detail-passwordProtected',
            type: 'error',
            text: 'Alle stiene må ha et brukernavn og et passord'
          })
        }
      })

      if (hasErrors) {
        return
      }

      const response = await this.runService(this, 'webhotel-detail-passwordProtected', WebhotelService.updatePasswordProtected, this.servername, this.state.passwordProtected)
      if (response) {
        this.goBack('Passordbeskyttelser har blitt oppdatert!')
      }
    },
    goBack (successMessage) {
      if (successMessage) {
        this.addNotification(false, {
          group: 'webhotel-list',
          type: 'success',
          text: successMessage
        })
      }
      this.$router.push({ name: 'webhotel-list' })
    }
  },
  computed: {
    servername () {
      return this.$route.params.servername
    }
  }
}
</script>
